<template>
  <ITextField v-model="innerValue" :name="name" type="textarea" :title="title" :rules="rules" :autocomplete="autocomplete" v-bind="attrs">
    <template #help><slot name="help" /></template>
  </ITextField>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue';
import ITextField from './ITextField.vue';

withDefaults(
  defineProps<{
    name: string;
    title?: string;
    rules?: string;
    autocomplete?: string;
  }>(),
  {
    title: '',
    rules: '',
    autocomplete: undefined,
  },
);
const innerValue = defineModel<string | number>();
const attrs = useAttrs();
</script>
